<div class="grid">
  <div class="col-12">
    <p-card class="h-100 w-100" header="Allgemein">
      <form [formGroup]="profileForm" (ngSubmit)="saveGeneral()">
        <div class="p-fluid grid mt-3">

          <div class="field col-12 md:col-6">
            <p-floatlabel>
              <input class="w-100" formControlName="first_name" id="first_name" type="text" pInputText/>
              <label for="first_name">Vorname</label>
            </p-floatlabel>
          </div>
          <div class="field col-12 md:col-6">
            <p-floatlabel>
              <input id="last_name" formControlName="last_name" class="w-100" type="text" pInputText/>
              <label for="last_name">Nachname</label>
            </p-floatlabel>
          </div>

          <div class="field col-12 md:col-6">
            <p-floatlabel>
              <input id="username" formControlName="username" class="w-100" type="text" pInputText/>
              <label for="username">Username</label>
            </p-floatlabel>
          </div>
          <div class="field col-12 md:col-6">
            <p-floatlabel>
              <input id="email" formControlName="email" class="w-100" type="text" pInputText/>
              <label for="email">E-Mail</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <p-button [disabled]="!profileForm.valid" type="submit" [outlined]="true">SPEICHERN</p-button>
        </div>

      </form>
    </p-card>
  </div>
  <div class="col-6">
    <p-card header="Avatar">
      <div class="">
        <div class="d-flex justify-content-center mb-3">
          <app-user-avatar [user]="auth.user() ?? undefined" [size]="'xlarge'"></app-user-avatar>
        </div>
        <div class="grid">
          <div class="col-6">
            <p-button styleClass="w-100" (click)="file.click()" [outlined]="true" class="w-100" label="DATEI AUSWÄHLEN"></p-button>
            <input #file type="file" [hidden]="true" (change)="uploadAvatar($event)">
          </div>
          <div class="col-6">
            <p-button label="AVATAR LÖSCHEN" (click)="deleteAvatar()" [outlined]="true" severity="danger" styleClass="w-100" class="w-100">
            </p-button>
          </div>
        </div>
      </div>
    </p-card>
  </div>
  <div class="col-6">
    <p-card header="Passwort ändern">
      <form [formGroup]="changePasswordForm" (ngSubmit)="changePW()">
        <div class="p-fluid grid">
          <div class="field col-12 mt-2">
            <p-floatlabel>
              <p-password id="current_password" [feedback]="false" formControlName="current_password" class="w-100"
                          [toggleMask]="true" inputStyleClass="w-100"></p-password>
              <label for="current_password">Jetziges Passwort</label>
            </p-floatlabel>
          </div>
          <div class="field col-12">
            <p-floatlabel>
              <p-password id="new_password" formControlName="new_password" class="w-100" [feedback]="false"
                          [toggleMask]="true" inputStyleClass="w-100">
              </p-password>
              <label for="new_password">Neues Passwort</label>
            </p-floatlabel>

            @if (changePasswordForm.controls['new_password'].value) {
              <div>
                <ul class="pl-2 mt-2 list-style-none" style="line-height: 1.5">
                  @for (rule of newPasswordRequirements | keyvalue; track rule) {
                    <li class="mb-2 text-{{rule.value.value ? 'success' : 'danger'}}"
                    >
                      <i class="pi pi-{{rule.value.value ? 'check' : 'times'}}"></i>
                      {{ rule.value.text }}
                    </li>
                  }
                </ul>
              </div>
            }

          </div>
          <div class="field col-12">
            <p-floatlabel>
              <p-password id="confirm_password" formControlName="confirm_password" inputStyleClass="w-100"
                          class="w-100" [feedback]="false" [toggleMask]="true"></p-password>
              <label for="confirm_password">Passwort bestätigen</label>
            </p-floatlabel>

            @if (changePasswordForm.controls['new_password'].value && changePasswordForm.controls['new_password'].value !== changePasswordForm.controls['confirm_password'].value) {
              <div class='mt-2 ml-2'>
                <div class="text-danger">
                  <i class="pi pi-times"></i>
                  Passwörter stimmen nicht überein
                </div>
              </div>
            }
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <p-button type="submit" [outlined]="true" [disabled]="!changePasswordForm.valid">SPEICHERN</p-button>
        </div>
      </form>
    </p-card>
  </div>
</div>
